<template>
  <div id="app">
    <div id="bk" style="display:none" class="bk" @click="open()"></div>
    <div id="menu" style="display:none" class="menu">
      <img
        @click="open()"
        class="img3"
        src="./assets/img/ICON_close_mob.svg"
        alt=""
      />
      <div @click="openabout()" class="one">
        关于昌恩 <img src="./assets/img/icon_arrow_r.svg" alt="" />
      </div>

      <ul id="mainMenu" style="display:none" class="mainMenu">
        <router-link :to="{ path: '/introduction' }">
          <li @click="open()">集团介绍</li></router-link
        >
        <router-link :to="{ path: '/project' }">
          <li @click="open()">案例展示</li></router-link
        >
        <router-link :to="{ path: '/qualification' }">
          <li @click="open()">资质中心</li></router-link
        >
        <router-link :to="{ path: '/ceo' }">
          <li @click="open()">董事长致辞</li></router-link
        >
      </ul>
      <div @click="openTwo()" class="one">
        <div>主营业务<img src="./assets/img/icon_arrow_r.svg" alt="" /></div>
      </div>

      <div id="twoMenu" style="display:none" class="twoMenu">
        <router-link :to="{ path: '/architecture' }">
          <div @click="open()">
            城市与建筑智能化
            <!-- <img class="img4" src="./assets/img/icon_arrow_r.svg" alt=""> -->
          </div>
        </router-link>

        <!-- <ul class="ml">
          <router-link :to="{ path: '/security' }">
            <li @click="open()">智能安防</li></router-link
          >
          <router-link :to="{ path: '/jianzhu' }"
            ><li @click="open()">建筑智能管理</li></router-link
          >
          <router-link :to="{ path: '/air' }"
            ><li @click="open()">中央空调节能智控</li></router-link
          >
        </ul> -->

        <router-link :to="{ path: '/architecture2' }"
          ><div @click="open()">智能交通</div></router-link
        >
        <!-- <ul class="ml">
          <router-link :to="{ path: '/technology' }"
            ><li @click="open()">科技治超</li></router-link
          >
          <router-link :to="{ path: '/monitor' }"
            ><li @click="open()">道路监控</li></router-link
          >
          <router-link :to="{ path: '/gps' }"
            ><li @click="open()">运营车辆管理</li></router-link
          >
        </ul> -->
      </div>
      <router-link :to="{ path: '/news' }"
        ><div class="one" @click="open()">新闻中心</div></router-link
      >
      <router-link :to="{ path: '/call' }">
        <div class="one" @click="open()">联系我们</div></router-link
      >
    </div>
    <div
      class="top"
      :class="{ active: showHeader, normal: prevScrollPos == 0 && showHeader }"
    >
      <img
        @click="open()"
        class="img1"
        src="./assets/img/icon-menu.png"
        alt=""
      />
      <div style="width: 50vw;">
        <img
          @click="home()"
          class="img2"
          src="./assets/img/logo_mob.png"
          alt=""
        />
      </div>
    </div>

    <router-view></router-view>
  </div>
</template>

<script>
import qs from "qs";
import axios from "axios";
export default {
  name: "App",
  data() {
    return {
      user: {
        username: "admin",
        password: "123456"
      },
      screenWidth: "",
      screenHeight: "",
      prevScrollPos: 0,
      showHeader: true,
      maskflag: false,
      timerID: null
    };
  },

  mounted() {
    // 滚动显示头部
    window.addEventListener("scroll", this.handleScroll);
    this.screenWidth = document.body.clientWidth;
    this.screenHeight = document.body.clientHeight;
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth;
        this.screenHeight = document.body.clientHeight;
        console.log(this.screenWidth + "@@@@@@@@@@@@");
        if (this.screenWidth > 800) {
          // window.location.href = "http://119.23.229.41:9088";
          window.location.href = "https://www.szce.com";
          // window.location.href = "http://192.168.20.170:9088";
        }
      })();
    };
    this.login();
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
    clearTimeout(this.timerID);
  },
  methods: {
    // 滚动显示头部
    handleScroll() {
      console.log("监听滚动");
      const currentScrollPos = window.scrollY;
      if (this.prevScrollPos > currentScrollPos) {
        this.showHeader = true;
      } else {
        this.showHeader = false;
      }
      this.prevScrollPos = currentScrollPos;
    },
    home() {
      this.$router.push("/");
    },

    open() {
      console.log("点击导航");
      clearTimeout(this.timerID);
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      document.getElementById("mainMenu").style.display = "none";
      document.getElementById("twoMenu").style.display = "none";
      var nowStatus = document.getElementById("menu");
      var bkStatus = document.getElementById("bk");
      if (nowStatus.style.display == "none") {
        nowStatus.classList.remove("maskHide");
        nowStatus.style.display = "block";
        bkStatus.style.display = "block";
      } else {
        nowStatus.classList.add("maskHide");
        // nowStatus.style.display = "none";
        this.timerID = setTimeout(() => {
          nowStatus.style.display = "none";
        }, 300);

        bkStatus.style.display = "none";
      }
    },
    openTwo() {
      //获取操作对象
      var nowStatus = document.getElementById("twoMenu");
      if (nowStatus.style.display == "none") {
        nowStatus.style.display = "block";
      } else {
        nowStatus.style.display = "none";
      }
    },
    openabout() {
      var nowStatus = document.getElementById("mainMenu");
      if (nowStatus.style.display == "none") {
        nowStatus.style.display = "block";
      } else {
        nowStatus.style.display = "none";
      }
    },
    login() {
      console.log("111111111111");
      axios({
        url: "https://www.szce.com/api/login",
        method: "post",
        data: qs.stringify(this.user),
        headers: { "Content-Type": "application/x-www-form-urlencoded" }
      }).then(res => {
        console.log(res.data.data.token);
        localStorage.setItem("token", res.data.data.token);
      });
    }
  },
  components: {}
};
</script>

<style scoped>
.active {
  top: 0; /* 激活状态，将头部显示在视口顶部 */
  position: fixed !important;
  top: 0px; /* 初始状态，将头部隐藏在视口上方 */
  width: 100%;
  transition: top 0.6s ease-in-out; /* 平滑过渡效果 */
  background-color: #030e2c;
  z-index: 555551111111 !important;
  border-bottom: 1px solid #eeebeb;
  animation-duration: 0.6s;
  animation-name: slidein;
}
@keyframes slidein {
  from {
    top: -100px;
  }

  to {
    top: 0px;
  }
}
.normal {
  background-color: rgba(0, 0, 0, 0) !important;
  position: relative !important;
  z-index: 0 !important;
}
.no-scroll {
  overflow: hidden;
}
html {
  font-size: 1vw;
}
* {
  margin: 0;
  padding: 0;
  /* 内减模式 */
  box-sizing: border-box;
}
body {
  margin: 0;
}
body::-webkit-scrollbar {
  width: 0; /* 隐藏滚动条 */
}
li {
  list-style: none;
}
a,
a:hover,
a:active,
a:visited,
a:link,
a:focus {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

  -webkit-tap-highlight-color: transparent;

  outline: none;

  background: none;

  text-decoration: none;
  color: #1d1d1d;
}
#app {
  position: relative;
  width: 100vw;
  height: 100%;
  overflow: hidden;
}

.img4 {
}
.menu {
  position: absolute;
  width: 66.6667vw;
  height: 100%;
  z-index: 12;
  background-color: #ffffff;
  display: none;
  animation: foldToHide 0.5s;
}

@keyframes foldToHide {
  from {
    left: -100px;
  }

  to {
    left: 0px;
  }
}

.maskShow {
  display: block;
}

.maskHide {
  display: none;
  animation: elHide 0.5s ease-in-out;
}
@keyframes elHide {
  from {
    left: 0px;
  }

  to {
    left: -280px;
  }
}
.bk {
  position: absolute;
  width: 100vw;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.77);
  display: none;
}

.img3 {
  display: block;
  width: 4.2667vw;
  margin-left: 5.3333vw;
  margin-top: 8vw;
  height: 4.2667vw;
  margin-bottom: 1.6vw;
}
.menu .one {
  position: relative;
  width: 66.6667vw;
  height: 16vw;
  padding-left: 5.3333vw;
  line-height: 16vw;
}
.menu .one img {
  position: absolute;
  float: right;
  width: 3.4667vw;
  height: 3.4667vw;
  right: 4vw;
  vertical-align: middle;
  top: 50%;
  transform: translate(0%, -50%);
}
.menu .mainMenu {
  margin-left: 10.667vw;
  display: none;
}
.menu .mainMenu li {
  font-size: 3.4667vw;
  height: 9.3333vw;
  line-height: 9.3333vw;
}

.menu .two {
  margin-top: 2.6667vw;
  padding-left: 5.3333vw;
  line-height: 10.6667vw;
}
.twoMenu {
  width: 66.6667vw;
  display: none;
}
.twoMenu2 {
  display: block;
}
.twoMenu div {
  width: 66.6667vw;
  height: 9.6vw;
  line-height: 9.6vw;
  margin-left: 10.6667vw;
}
.menu .two img {
  width: 3.4667vw;
  height: 3.4667vw;
  margin-left: 38.9333vw;
}
.top {
  width: 100vw;
  height: 16vw;
  background-color: #ffffff;
  display: flex;
}
.img1 {
  float: left;
  width: 5.3333vw;
  height: 5.3333vw;
  display: inline-block;
  margin: 5.3333vw 0 5.3333vw 5.3333vw;
}

.img2 {
  display: block;
  float: left;
  width: 27.8667vw;
  height: 6.6667vw;
  margin: 4.4vw 36vw 4.9333vw 25.4667vw;
  object-fit: contain;
}
.ml {
  margin-left: 21.3333vw;
}
.ml li {
  height: 9.3333vw;
}
</style>



// WEBPACK FOOTER //
// src/App.vue